import React from "react";
import { useEffect, useRef, useState } from "react";
import LeftChevronIcon from '../../../components/Icons/LeftChevronIcon';
import RightChevronIcon from '../../../components/Icons/RightChevronIcon';
import MainBtn from '../../../components/MainBtn';
import monthRangeStyle from "./monthRangePicker.module.css";
const MonthRangePicker = ({
  containerWidth,
  setStartMonth,
  setEndMonth,
  openState,
  parentRef,
  focusState,
  applyFunc,
  cancelFunc,
  darkTheme,
  years,
  selectedPeriodRange,
  setYear,
  setGlobalStartMonth,
  setGlobalEndMonth,
}) => {
  const containerRef = useRef(null);

  const compareMonth = (firstMonth, firstYear, lastMonth, lastYear) => {
    if (lastYear > firstYear) {
      return true;
    }
    if (lastYear === firstYear) {
      if (lastMonth >= firstMonth) {
        return true;
      }

      return false;
    }

    return false;
  };

  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  var earliestYear = years[0];
  var latestYear = years[years.length-1];
  const [year1, setYear1] = useState(selectedPeriodRange?.selectedYear || years[0]);
  const [year2, setYear2] = useState(2023);

  const [hoverMonth, setHoverMonth] = useState(selectedPeriodRange?.startMonth);
  const [hoverYear, setHoverYear] = useState(selectedPeriodRange?.selectedYear);

  const [selectedFirstMonth, setSelectedFirstMonth] = useState(selectedPeriodRange?.startMonth);
  const [selectedFirstYear, setSelectedFirstYear] = useState(selectedPeriodRange?.selectedYear);

  const [selectedLastMonth, setSelectedLastMonth] = useState(selectedPeriodRange?.endMonth);
  const [selectedLastYear, setSelectedLastYear] = useState(selectedPeriodRange?.selectedYear);

  function handleClickOutside(event) {
    event.preventDefault();
    if (
      containerRef.current &&
      !containerRef.current.contains(event.target) &&
      !parentRef.current.contains(event.target)
    ) {
      openState(false);
      focusState(false);
    }
  }

  const getColor = (month, year) => {
    if (selectedFirstMonth === month && selectedFirstYear === year) {
      return monthRangeStyle.calenderCellStart;
    }
    if (selectedLastMonth === month && selectedLastYear === year) {
      return monthRangeStyle.calenderCellEnd;
    }
    if (selectedFirstMonth !== null && selectedLastMonth !== null) {
      if (
        compareMonth(selectedFirstMonth, selectedFirstYear, month, year) &&
        compareMonth(month, year, selectedLastMonth, selectedLastYear)
      ) {
        return `${monthRangeStyle.calenderCellInbetween} ${darkTheme && monthRangeStyle.calenderCellInbetweenDark}`;
      }
    }
    if (selectedFirstMonth !== null && selectedLastMonth === null) {
      if (
        compareMonth(selectedFirstMonth, selectedFirstYear, month, year) &&
        compareMonth(month, year, hoverMonth, hoverYear)
      ) {
        return `${monthRangeStyle.calenderCellInbetween} ${darkTheme && monthRangeStyle.calenderCellInbetweenDark}`;
      }
    }
    return `${monthRangeStyle.calenderCellNormal} ${
      darkTheme && monthRangeStyle.calenderCellNormalDark
    }`;
  };

  const calenderClick = (month, year) => {
    if (selectedLastYear !== null && selectedLastMonth !== null) {
      setSelectedLastYear(null);
      setSelectedLastMonth(null);
      setSelectedFirstYear(year);
      setSelectedFirstMonth(month);
      return;
    }

    if (selectedFirstYear !== null && selectedFirstMonth !== null) {
      if (month === selectedFirstMonth && year === selectedFirstYear) {
        return;
      }

      if (compareMonth(selectedFirstMonth, selectedFirstYear, month, year)) {
        setSelectedLastMonth(month);
        setSelectedLastYear(year);
      } else {
        setSelectedFirstMonth(month);
        setSelectedFirstYear(year);
      }
      return;
    }
    setSelectedFirstMonth(month);
    setSelectedFirstYear(year);
  };

  const resetAll = () => {
    setSelectedFirstMonth(null);
    setSelectedFirstYear(null);
    setSelectedLastMonth(null);
    setSelectedLastYear(null);
    setHoverMonth(null);
    setHoverYear(null);
    openState(false);
    focusState(false);
  };

  const applyMonths = () => {
    setStartMonth({ selectedFirstMonth, selectedFirstYear });
    setEndMonth({ selectedLastMonth, selectedLastYear });
    localStorage.setItem("selectedPeriodRange", JSON.stringify({selectedYear: year1, startMonth: selectedFirstMonth, endMonth: selectedLastMonth}))
    setYear(year1);
    setGlobalStartMonth(selectedFirstMonth);
    setGlobalEndMonth(selectedLastMonth);
    applyFunc && applyFunc();
    resetAll();
  };

  const cancelButton = () => {
    setStartMonth({ selectedFirstMonth: null, selectedFirstYear: null });
    setEndMonth({ selectedLastYear: null, setSelectedLastYear: null });
    cancelFunc && cancelFunc();
    resetAll();
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const containerTheme = {
    width: containerWidth,
  };
  return (
    <>
      <div
        ref={containerRef}
        className={`${monthRangeStyle.monthRangeContainer} ${
          darkTheme && monthRangeStyle.monthRangeContainerDark
        }`}
        style={containerTheme}
      >
        <div
          className={`${monthRangeStyle.monthRangePicker} ${
            darkTheme && monthRangeStyle.monthRangePickerDark
          }`}
        >
          <div
            className={`${monthRangeStyle.leftCalender} ${
              darkTheme && monthRangeStyle.leftCalenderDark
            }`}
          >
            <div className={monthRangeStyle.upperLayer}>
              <button
                disabled={year1 <= earliestYear}
                className={`${monthRangeStyle.upperButton} ${darkTheme && monthRangeStyle.upperButtonDark}`}
                onClick={() => {
                  setYear1(year1 - 1);
                  // setYear2(year2 - 1);
                }}
              >
                <LeftChevronIcon disabled={year1 <= earliestYear} />
              </button>
              <div
                className={`${monthRangeStyle.yearName} ${
                  darkTheme && monthRangeStyle.yearNameDark
                }`}
              >
                {year1}
              </div>
              <button
                disabled={year1 >= latestYear}
                className={`${monthRangeStyle.upperButton} ${darkTheme && monthRangeStyle.upperButtonDark}`}
                onClick={() => {
                  setYear1(year1 + 1);
                  // setYear2(year2 + 1);
                }}
              >
                <RightChevronIcon disabled={year1 >= latestYear} />
              </button>
            </div>
            <div className={monthRangeStyle.blockContainer}>
              {months.map((month, i) => {
                return (
                  <div
                    key={`${i} ${year1}`}
                    className={`${monthRangeStyle.calenderCell} ${getColor(
                      i,
                      year1
                    )}`}
                    onMouseEnter={() => {
                      setHoverYear(year1);
                      setHoverMonth(i);
                    }}
                    onMouseLeave={() => {
                      setHoverYear(null);
                      setHoverMonth(null);
                    }}
                    onClick={() => {
                      calenderClick(i, year1);
                    }}
                  >
                    {month}
                  </div>
                );
              })}
            </div>
          </div>
          {/* <div
            className={`${monthRangeStyle.rightCalender} ${
              darkTheme && monthRangeStyle.rightCalenderDark
            }`}
          >
            <div className={monthRangeStyle.upperLayer}>
              <div className={`${monthRangeStyle.yearName} ${darkTheme && monthRangeStyle.yearNameDark}`}>{year2}</div>
              <button
                className={`${monthRangeStyle.upperButton} ${darkTheme && monthRangeStyle.upperButtonDark}`}
                onClick={() => {
                  setYear1(year1 + 1);
                  setYear2(year2 + 1);
                }}
              >
                {">"}
              </button>
            </div>
            <div className={monthRangeStyle.blockContainer}>
              {months.map((month, i) => {
                return (
                  <div
                    key={`${i} ${year2}`}
                    className={`${monthRangeStyle.calenderCell} ${getColor(
                      i,
                      year2
                    )}`}
                    onMouseEnter={() => {
                      setHoverYear(year2);
                      setHoverMonth(i);
                    }}
                    onMouseLeave={() => {
                      setHoverYear(null);
                      setHoverMonth(null);
                    }}
                    onClick={() => {
                      calenderClick(i, year2);
                    }}
                  >
                    {month}
                  </div>
                );
              })}
            </div>
          </div> */}
        </div>
        <div
          className={`${monthRangeStyle.accessories} ${
            darkTheme && monthRangeStyle.accessoriesDark
          }`}
        >
          {/* <button
            className={`${monthRangeStyle.buttonCommon} ${monthRangeStyle.applyButton}`}
            onClick={applyMonths}
            disabled={
              !(
                (selectedLastMonth || selectedLastMonth === 0) &&
                selectedLastYear
              )
            }
          >
            Apply
          </button>
          <button
            className={`${monthRangeStyle.buttonCommon} ${monthRangeStyle.cancelButton} ${darkTheme && monthRangeStyle.cancelButtonDark}`}
            onClick={cancelButton}
          >
            Cancel
          </button> */}
          <MainBtn title="Apply" onClick={applyMonths} disabled={
            !(
              selectedFirstYear
            )
          } />
          <a className="cancelButton mr-4" onClick={cancelButton}>Cancel</a>
        </div>
      </div>
    </>
  );
};

export default MonthRangePicker;
